<app-page>
    <app-table-layout [columns]="deviceService.ifMobile(1).orElse(3)" [items]="3">
        <div #layout>
            <app-top-locations [year]="year"></app-top-locations>
        </div>
        <div #layout>
            <app-top-locations [year]="year" [month]="month"></app-top-locations>
        </div>
        <div #layout>
            <app-top-locations [year]="year" [month]="month" [day]="day"></app-top-locations>
        </div>
    </app-table-layout>
</app-page>
